export default __webpack_public_path__ + "static/media/linux.353c19bc957088d7c74af914e36c761e.svg";